<!-- app/javascript/dashboard/components-next/sidebar/LabelFilterBar.vue -->
<!-- CUSTOM: bocket-multi-label-filter -->
<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  selectedLabels: { type: Array, required: true },
});

const emit = defineEmits(['removeLabel', 'clear']);
const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-wrap gap-1 items-center px-3 py-1.5 mx-1 mb-1 rounded-lg bg-n-alpha-1 border border-n-weak"
  >
    <span
      v-for="labelTitle in selectedLabels"
      :key="labelTitle"
      class="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-n-brand/20 text-n-brand cursor-pointer hover:bg-n-brand/30 transition-colors max-w-[90px]"
      :title="labelTitle"
      @click="emit('removeLabel', labelTitle)"
    >
      <span class="truncate">{{ labelTitle }}</span>
      <!-- eslint-disable-next-line vue/no-bare-strings-in-template -- glifo decorativo, no texto de usuario -->
      <span class="text-[9px] opacity-60 flex-shrink-0">×</span>
    </span>
    <span
      class="text-[10px] text-n-slate-10 underline cursor-pointer hover:text-n-slate-11 ml-auto transition-colors"
      @click="emit('clear')"
    >
      {{ t('CHAT_LIST.LABEL_FILTER.CLEAR') }}
    </span>
  </div>
</template>
